import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const AccountPage = lazy(() => import('./AccountPage'));

const routes: RouteObject[] = [{ path: '/account', element: <AccountPage /> }];
export default routes;
